import Api from '../../../../services/Api';
import { ApiResponse } from 'apisauce';
import {
  ReportChainResponse,
  ReportChainUpdateRequest,
  ReportChainUpdateResult,
  ReportChainMoveRequest,
  ReportChainCompleteStepRequest,
} from '../types';

export const GET_REPORT_CHAIN = 'GET_REPORT_CHAIN';
export const CLEAR_REPORT_CHAIN = 'CLEAR_REPORT_CHAIN';

export const saveReportChainToStore = (chain: ReportChainResponse) => {
  return {
    type: GET_REPORT_CHAIN,
    value: chain,
  };
};

export const clearReportChain = () => {
  return {
    type: CLEAR_REPORT_CHAIN,
  };
};

export const getReportChainByOck = (url: string, originalCrashKey: string) => {
  return async (dispatch) => {
    try {
      const result: ApiResponse<any> = await Api.get(
        `${url}?originalCrashKey=${encodeURIComponent(originalCrashKey)}`
      );
      if (result.ok) {
        dispatch(saveReportChainToStore(result.data as ReportChainResponse));
        return Promise.resolve(result.data as ReportChainResponse);
      }
      return Promise.reject(result.data);
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const saveReportChainCorrections = (
  url: string,
  request: ReportChainUpdateRequest
) => {
  return async (dispatch) => {
    try {
      const result: ApiResponse<any> = await Api.post(url, request);
      const data = result.data as ReportChainUpdateResult;
      if (result.ok && data && data.success && data.updatedChain) {
        dispatch(saveReportChainToStore(data.updatedChain));
      }
      return Promise.resolve(data);
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const moveReportToStep = (
  url: string,
  request: ReportChainMoveRequest
) => {
  return async (dispatch) => {
    try {
      const result: ApiResponse<any> = await Api.post(url, request);
      const data = result.data as ReportChainUpdateResult;
      if (result.ok && data && data.success && data.updatedChain) {
        dispatch(saveReportChainToStore(data.updatedChain));
      }
      return Promise.resolve(data);
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const completeReportStep = (
  url: string,
  request: ReportChainCompleteStepRequest
) => {
  return async (dispatch) => {
    try {
      const result: ApiResponse<any> = await Api.post(url, request);
      const data = result.data as ReportChainUpdateResult;
      if (result.ok && data && data.success && data.updatedChain) {
        dispatch(saveReportChainToStore(data.updatedChain));
      }
      return Promise.resolve(data);
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
